import { FC } from 'react'
import styles from 'components/features/publicDashboard/HowSpendingCompare/HowSpendingCompare.styl'
import Button from 'components/features/pfm/Button/Button'
import { PublicDashboardModuleWrapper } from 'components/features/external/PublicDashboardModuleWrapper/PublicDashboardModuleWrapper'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'

export const HowSpendingCompare: FC = () => {
  return (
    <PublicDashboardModuleWrapper>
      <div className={ styles.howSpendingCompare }>
        <h1>
          How does your spending compare?
        </h1>
        <div>
          See how your finances compare with people like you. Members reduce their
          spending by 23% on average after seeing their peer comparisons.
        </div>
        <NavigationLink to='onboarding-register'>
          <Button>COMPARE YOUR SPENDING</Button>
        </NavigationLink>
      </div>
    </PublicDashboardModuleWrapper>
  )
}
